import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppMessageService } from '../../../../shared/services/app-message/app-message.service';
import { Router } from '@angular/router';
import { AuthService } from '../../../../shared/services/auth/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent {
  resetPasswordForm: FormGroup;
  showPassword: boolean = false;
  showPasswordConfirm: boolean = false;
  email: string = '';
  otpCode: string = '';

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly appMessageService: AppMessageService,
    private readonly router: Router,
    private readonly authService:AuthService
  ) {
    this.resetPasswordForm = this.formBuilder.group(
      {
        password: ['', Validators.required],
        passwordConfirm: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(30),
            this.passwordPatternValidator(),
          ],
        ],
      },
      { validator: this.passwordsMatchValidator }
    );
    const navigation = this.router.getCurrentNavigation();
    this.email = navigation?.extras?.state?.['email'] ?? '';
    this.otpCode = navigation?.extras?.state?.['otp'] ?? '';

  }


  togglePasswordVisibility(field: string) {
    if (field === 'password') {
      this.showPassword = !this.showPassword;
    } else if (field === 'passwordConfirm') {
      this.showPasswordConfirm = !this.showPasswordConfirm;
    }
  }

  submitForm() {
    if (this.resetPasswordForm.valid && this.email) {
      this.authService.postForgetPassword({
        email:this.email,
        otpCode:this.otpCode,
        ...this.resetPasswordForm.value
      }).subscribe({
        next:res=>{
          this.appMessageService.successToast(
            'Başarılı!',
            'Şifre Başarıyla Güncellendi',
            20000,
            'top-right'
          );
          this.router.navigate(['auth/login'])
        }
      })
    }
  }

  passwordPatternValidator() {
    return Validators.pattern(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{4,30}$/
    );
  }

  passwordsMatchValidator(formGroup: FormGroup) {
    const passwordControl = formGroup.get('password');
    const passwordConfirm = formGroup.get('passwordConfirm');

    if (
      passwordControl &&
      passwordConfirm &&
      passwordControl.value !== passwordConfirm.value
    ) {
      passwordConfirm.setErrors({ passwordsMismatch: true });
    } else {
      passwordConfirm?.setErrors(null);
    }
  }
}
